/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Tools_TitleInputs */

const en_home_tools_title = /** @type {(inputs: Home_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ten tools, one private workspace`)
};

const ko_home_tools_title = /** @type {(inputs: Home_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10가지 도구, 하나의 프라이빗 작업 공간`)
};

const ja_home_tools_title = /** @type {(inputs: Home_Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10のツール、ひとつのプライベート作業環境`)
};

/**
* | output |
* | --- |
* | "Ten tools, one private workspace" |
*
* @param {Home_Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const home_tools_title = /** @type {((inputs?: Home_Tools_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Tools_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_tools_title(inputs)
	if (locale === "ko") return ko_home_tools_title(inputs)
	return ja_home_tools_title(inputs)
});